/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_News_Reportctabody2Inputs */

const ja_playdata_news_reportctabody2 = /** @type {(inputs: Playdata_News_Reportctabody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新のPLAYDATAレポートを無料で配布中です。お問い合わせフォームよりお申し込みいただくと、ご登録いただいたメールアドレス宛にお送りいたします。`)
};

const en_playdata_news_reportctabody2 = /** @type {(inputs: Playdata_News_Reportctabody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The latest PLAYDATA report is available free on request. Contact us and we will send it to the address you register.`)
};

/**
* | output |
* | --- |
* | "The latest PLAYDATA report is available free on request. Contact us and we will send it to the address you register." |
*
* @param {Playdata_News_Reportctabody2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_news_reportctabody2 = /** @type {((inputs?: Playdata_News_Reportctabody2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_News_Reportctabody2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_news_reportctabody2(inputs)
	return en_playdata_news_reportctabody2(inputs)
});
export { playdata_news_reportctabody2 as "playdata_news_reportCtaBody" }